/*
 Author : Jérome Martin

 Markup :
 <div class=".js-magReader"> </div>

 Setup :
 $(function() {
 $(".js-magReader").reader();
 });

 */

;(function ( $, window, document, undefined ) {
    var pluginName = "reader",
        defaults = {
        };

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function() {
            var that = this;
            $(that.element).hide();

            cmp.getCmpConsent('purpose', cmp.getKeyForPurpose('essentials')).then(function(consent) {
                if (consent) {
                    that.loadScript();
                    that.setVars();
                    that.setEvents();
                }
            })
        },

        loadScript : function(){
            var that= this;

            $.when(
                $.getScript( "/js/nc-vendors/mlfoundation.js" ),
                $.getScript( "/js/nc-vendors/reader.js" ),
                $.Deferred(function( deferred ){
                    $( deferred.resolve );
                })
            ).done(function(){
                that.data.scriptLoaded=true;
            });



        },

        setVars:function(){
            this.data={};
            this.data.scriptLoaded=false;
            this.data.playerHtml5=false;
            this.data.playerHtml5Conf = {
                'selector': '#liseuse-container',
                'ticket':'vide',
                'closeButton':function(){
                    location.href="/";
                },
                'theme':{
                    "backgroundColor":'#FFFFFF',
                    "topbarLogo":"/img/logo_milibris.png",
                    "topbarLogoIcon":"/img/logo_milibris.png",
                    "topbarIconColor":"#cf0000",
                    "articleTopbarIconColor":"#cf0000",
                    "articleBackgroundColor":'#000000',
                    "articleLogo":"/img/logo_milibris.png"
                }
            };
        },

        setData :function(right,html){
            var that = this;
            that.data.right=right;
            that.data.html=html;
        },

        setToken : function(token){
            var that = this;
            that.data.token = token;
            that.data.playerHtml5Conf = $.extend( {}, that.data.playerHtml5Conf, {'ticket':that.data.token}) ;
        },

        run:function(){
            var that = this;
            if(that.data.scriptLoaded!=true)
            {
                console.warn("Le script milibris n' est pas chargé ");
                return false;
            }

            if(that.data.right==true) {

                if(that.data.html!="")
                {
                    $(that.element).append(that.data.html);
                    var html5Player = $(that.element).find(".js-html5-player");

                    /**la variable liseuse_token et envoyer par le html**/
                    that.data.playerHtml5=html5Player.length;
                    that.setToken(liseuse_token);
                    if(that.data.playerHtml5==1){

                        var width = screen.availWidth;
                        var height = $(window).height() - $('.header').height();
                        $('.container-main').css("max-width", "initial");
                        html5Player.css({width: width, height:height});

                        that.data.liseuse=MilibrisReader;
                        that.data.liseuse.load(that.data.playerHtml5Conf);
                    }else {
                        that.data.liseuse = new MLFoundation(that.data.token, 'reader');
                        that.data.liseuse.startReader();
                    }


                }else{
                    that.showMessage("error","Cette édition n'est pas disponible.");
                }

            }else{
                that.showMessage("error","Vous n'avez pas accès à cette édition.");
            }
            that.resize();
            $(that.element).show();
        },

        setEvents: function() {
            var that = this;
            $(window).on("resize", function() {
               that.resize();
            });
        },

        resize:function(){
            var height = $(window).height() - $(".header").height();
            $(this.element).find("#reader").css("height", height);
        },

        showMessage: function (type, message) {
            if (message) {
               if (popin) {
                    var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
                    html += '<p class="paragraph"><span class="message message--error">' + message +'</span></p>';
                    html += '</div>';
                    popin.setPopin({
                        html: html,
                        classname: "popin popin--xs popin--auto"
                    });
                }
            }
        }
    });

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                    new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );